import { useTheme } from 'styled-components';

import { Typography } from '../../../designComponents';
import { blueprintData } from './data';
import Details from './Details';
import { BluePrintStyled, ContainerStyled } from './style';

const BluePrintDevelopment = () => {
  const theme = useTheme();
  return (
    <BluePrintStyled>
      <ContainerStyled>
        <div className="main-text">
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
            className="text"
          >
            <Typography
              style={{ color: theme.colors.landingSecondaryText }}
              variant="heading"
              strong
            >
              Seamless Process for
            </Typography>
            <Typography
              style={{ color: theme.colors.skyBlueLight }}
              variant="heading"
              strong
            >
              Blueprint Development
            </Typography>
          </div>
          <Typography variant="title" className="title">
            In today's fast-paced world, navigating complex processes can be
            daunting. That's why at EscapePlan, we've designed a straightforward
            and intuitive approach to building blueprint creation. Our
            streamlined process eliminates unnecessary steps, making it easy for
            clients to convert their building drawings into precise and
            compliant plans.
          </Typography>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '30px',
            backgroundColor: theme.colors.greeenfadeLight,
          }}
        >
          {blueprintData.map((data, idx) => (
            <Details
              id={idx + 1}
              desc={data.desc}
              label={data.label}
              key={idx}
            />
          ))}
        </div>
      </ContainerStyled>
    </BluePrintStyled>
  );
};

export default BluePrintDevelopment;
